import { useQuery } from "@tanstack/react-query";
import { SecurityAppInvestigationsSummary } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
const fetchAvailability = () => SecurityAppInvestigationsSummary.reportAvailability().then((response) => {
  var _a;
  return {
    available: response.available,
    message: (_a = response.message) != null ? _a : void 0
  };
});
const useInvestigationReportAvailability = (enabled) => {
  const { data, isLoading } = useQuery({
    queryKey: ["investigation-ai-report", "availability"],
    queryFn: () => defaultOnError(
      fetchAvailability(),
      "Checking whether AI reports are available failed",
      "Could not check AI report availability"
    ),
    enabled
  });
  return { data: data != null ? data : { available: false, message: void 0 }, isLoading: enabled && isLoading };
};
export default useInvestigationReportAvailability;
